module.exports = (fox) => ({

	hoverPreviewVideo(elt, w) {
		var elt = jQuery(elt).parent();
		elt.addClass('loaderhover');
		if (fox.utils.isTouchDevice()){
			this.mobileClearItems(elt)
		}
		if(w.imgInt){
			clearInterval(w.imgInt);
		}
		var video = jQuery(elt).find('video')[0];
		elt.addClass('previewVideo');
		var primaryImg = jQuery(elt).find('.lazyloaded');
		if (video) {
			video.setAttribute('src', video.getAttribute('data-src'));
			video.muted = "muted";
			if(video.getAttribute('src')){
				video.oncanplay = function() {
					if(elt.hasClass('previewVideo')){
						$(primaryImg).addClass('_hidden');
					}
				} 
			}
			video.play;
			
		} else {
			var arr = jQuery(elt).find('.loadImg');
			var i = 0;
			var l = arr.length;
			w.imgInt = setInterval(() => {
				
				var elemCurrent = arr[i];
				var prevImg = (i == 0) ? arr[l-1] : arr[i-1];
				if (!elemCurrent.getAttribute('src')){
					elemCurrent.setAttribute('src', elemCurrent.getAttribute('data-img'));
					elemCurrent.onload = ()=>{
						$(primaryImg).addClass('_hidden');
						jQuery(prevImg).addClass('_hidden');
						elemCurrent.classList.remove('_hidden');
					}
				}else{
					$(primaryImg).addClass('_hidden');
					jQuery(prevImg).addClass('_hidden');
					elemCurrent.classList.remove('_hidden');
				}
				i++;
				if(i==l) i=0;
			},1000)
		}
		setTimeout(() => {
			elt.removeClass('loaderhover');
		}, 1500);
		
	},
	
	stopHoverPreviewVideo(el, w) {
		var parent = jQuery(el).parent();
		var p = jQuery(parent);
		p.find('.lazyloaded').removeClass('_hidden');
		p.removeClass('previewVideo');
		p.removeClass('loaderhover');
		var video = parent.find('video')[0];
		if (video) {
			video.pause();
			video.removeAttribute('src');
		}
		else {
			var arr = parent.find('.loadImg');
			arr.map((i, elm)=>{
				jQuery(elm).addClass('_hidden')
			})
			clearInterval(w.imgInt);
		}
	},

	followingLink(elm) {
		var elt = jQuery(elm).parent();
		var path = jQuery(elt).find('>a').attr('href');
		path = path.substr(1);
		fox.site.gotoPage(path);
	},

	handleTouch(el, w){
		var isMoving = false;
		var self = this;
		el.map((elm) => {
			fox.jQuery(elm).on('touchstart', function(e) {
				var swipe = e.originalEvent.touches,
				start = swipe[0].pageX;

				//e.preventDefault();
				e.stopPropagation();
				$(elm).on('touchmove', function(e) {
				//e.preventDefault();
				e.stopPropagation();
			
					var contact = e.originalEvent.touches,
					end = contact[0].pageX,
					distance = end-start;

					if (distance > 30 || distance < -30) {
						console.log('right');
						self.hoverPreviewVideo(elm, w);
						isMoving = true;
					}
				}.bind(this))
				.one('touchend', function() {
					if (!isMoving) {
						return;
					}
					isMoving = false;
					$(elm).off('touchmove touchend');
				}.bind(this));
			}.bind(this));
		})
	},
	mobileClearItems(elt){
		if (elt.hasClass('previewVideo')){
			elt.removeClass('previewVideo');
		}
		
		var allprimaryImg = fox.dom.select('.lazyloaded');
		var allVideo = fox.dom.select('.hov-video');
		var allHoverImg = fox.dom.select('.loadImg')
		allHoverImg.map((item) => {
			item.classList.add('_hidden');
		});
		allprimaryImg.map((item) => {
			item.classList.remove('_hidden');
		});
		allVideo.map((item) => {
			jQuery(item.parentElement.parentElement).removeClass('previewVideo');
			item.pause();
			item.removeAttribute('src');
		})
	}

});


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/hoverVideo/index.es.js